import { useState, useCallback } from 'react';

const AZERTY_MAP = {
  '&': '1',
  'é': '2',
  '"': '3',
  "'": '4',
  '(': '5',
  '-': '6',
  'è': '7',
  '_': '8',
  'ç': '9',
  'à': '0',
  // Ajoutez d'autres mappings selon vos besoins
};

const useAzertyConverter = () => {
  const [convertedValue, setConvertedValue] = useState('');
  const [isNumpad, setIsNumpad] = useState(false);

  const handleKeyDown = useCallback((e) => {
    setIsNumpad(e.location === 3);
  }, []);

  const convertInput = useCallback((value) => {
    if (!value) return '';
    
    // Récupérer le dernier caractère
    const lastChar = value.slice(-1);
    
    // Si le caractère vient du pavé numérique, ne pas convertir
    if (isNumpad) {
      setConvertedValue(value);
      return value;
    }
    
    // Si le dernier caractère est dans notre mapping, le remplacer
    if (AZERTY_MAP[lastChar]) {
      const newValue = value.slice(0, -1) + AZERTY_MAP[lastChar];
      setConvertedValue(newValue);
      return newValue;
    }
    
    setConvertedValue(value);
    return value;
  }, [isNumpad]);

  const handleInputChange = useCallback((e) => {
    const value = e.target.value;
    const converted = convertInput(value);
    e.target.value = converted;
    return converted;
  }, [convertInput]);

  return {
    convertedValue,
    convertInput,
    handleInputChange,
    handleKeyDown
  };
};

export default useAzertyConverter; 